import { useEffect, useState } from "react";
import fundoSection from "../../images/Logo/fundo-section.svg";
import { getNoticias } from "../../service/noticiaService";

const ROTATE_INTERVAL = 5000; // ⏱️ alterna a cada 5s

export default function NewsSection() {
  const [destaques, setDestaques] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    async function load() {
      const data = await getNoticias();
      const apenasDestaques = data.filter((n) => Number(n.destaque) === 1);
      setDestaques(apenasDestaques);
    }
    load();
  }, []);

  // Rotação automática
  useEffect(() => {
    if (destaques.length <= 3) return;

    const interval = setInterval(() => {
      setIndex((prev) => (prev + 3) % destaques.length);
    }, ROTATE_INTERVAL);

    return () => clearInterval(interval);
  }, [destaques]);

  // pegar os 3 da vez
  const exibicao = destaques.slice(index, index + 3);

  // caso não tenha 3 disponíveis no slice, completar do início
  if (exibicao.length < 3 && destaques.length > 3) {
    exibicao.push(...destaques.slice(0, 3 - exibicao.length));
  }

  return (
    <section
      className="min-h-screen bg-no-repeat bg-cover relative overflow-hidden"
      style={{
        backgroundImage: `url(${fundoSection})`,
      }}>
      <div className="relative z-10">
        <div className="flex items-start justify-between p-8">
          <div>
            <h2 className="text-4xl font-bold">Nossa Últimas Notícias</h2>
            <p className="text-gray-800">
              Fique por dentro das últimas novidades
            </p>
          </div>
          <a
            href="/noticias"
            className="inline-flex items-center px-4 py-2 border border-purple-600 text-purple-600 rounded-md hover:bg-purple-600 hover:text-white transition-colors duration-200 bg-transparent">
            MAIS NOTÍCIAS
            <svg
              className="ml-2 h-4 w-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-8">
          {exibicao.map((news) => (
            <div
              key={news.id}
              className="bg-white-50 border-2 border-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300"
              style={{
                boxShadow:
                  "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px",
              }}>
              <div className="aspect-w-16 aspect-h-9 overflow-hidden">
                <img
                  src={news.imagem || "/placeholder.svg"}
                  alt={news.titulo}
                  className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300 p-2"
                />
              </div>
              <div className="p-6">
                <p className="text-sm text-gray-500 mb-3">
                  {news.data_publicacao}
                </p>
                <h3 className="text-lg font-semibold mb-3 line-clamp-2">
                  {news.titulo}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-4">
                  {news.descricao}
                </p>
                <a
                  href={`/noticia/${news.id}`}
                  className="inline-flex items-center text-purple-600 hover:text-purple-800 font-medium text-sm transition-colors">
                  Leia mais
                  <svg
                    className="ml-1 h-3 w-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
